import digitalData from './digitalData';
import { updateDataLayer, nullCheck } from './utils';
import CustomEvent from 'custom-event';
import cloneDeep from 'lodash/cloneDeep';
import {PageInfo} from './dataObjects';
import { setPageInfo } from './utils';
window.digitalData = digitalData || {};
const isMybizMfeOmni = window['mbtGlobal']?.mfeConfig?.nseMFEEnabled;
//Globle Initializing OMNI
window['zincTag'] = window['zincTag'] || [];

window.redirectionExecuted = false;
export default function init() {
    if(!window.digitalData) {
        window.digitalData = cloneDeep(digitalData); 
    }
}
 

export function getQueryParam(query){
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(query);
}
export function dispatchEvent(eventName, data) {
    //updateDataLayer()
    const event = new CustomEvent(eventName, {
        detail: data
    });
    window.addEventListener('Virtual Page View',function (e) {
        console.log('Virtual Page View fired  '+ window['digitalData'].pageInfo.pageName);
    });
    if (!isMybizMfeOmni) {
        window.dispatchEvent(event);
    }
}

export function contactUsLanding() {
    updateDataLayer('app-contact-us-landing', 'contact_us', 'contact_us', 3, '');
}

export function dynamicComponentRendered(eData) {
    const componentRenderedEventPayload = {
        'eventName': "Dynamic Component Rendered",
        'eventPayload': eData
    };

    const cusEvent = new CustomEvent(componentRenderedEventPayload.eventName, {
        detail: componentRenderedEventPayload,
        bubbles: true,
        cancelable: true
    });
    window['digitalData'].pageInfo['currentSection'] = eData?.sectiontName;
    window['digitalData'].pageInfo['currentSubSection'] = eData?.subSection;

    window.dispatchEvent(cusEvent);
    window['digitalData'].events.push(componentRenderedEventPayload);
}
export function dispatchErrorEvent(data) {
    const event = new CustomEvent('Error', {
        detail: data
    });
    window.dispatchEvent(event);
}

export function setPageVisitor() {
    if(window.location.pathname.indexOf('/secure/') > -1 && window['mbtGlobal']?.ecpdId) {
        window['digitalData'].visitorProfile.ecpdId = window['mbtGlobal'].ecpdId;
        window['digitalData'].visitorProfile.email = window['mbtGlobal'].userEmail;
        window['digitalData'].visitorProfile.userId = window['mbtGlobal'].userId;
        window['digitalData'].visitorProfile.visitorECID = window['mbtGlobal'].ecpdId;
    }
}

export function trackPageInfo(pageName) {
    try {
        if (!isMybizMfeOmni) {    
            setPageVisitor();
            let pageInfo = setPageInfo(PageInfo);
            pageInfo.pageName = `${pageInfo.pageName}:${pageName}`;
            window['digitalData'] && (window.digitalData.pageInfo =  pageInfo);
            window.digitalData.events.push({eventName: "Virtual Page View", eventPayload: {...pageInfo}});
            dispatchEvent('Virtual Page View', {eventName: "Virtual Page View", ...pageInfo});
        }
    } catch(err) {
        console.log(err);
    }
}

export function eventTrackingDL(eventName, eData) {
    try{
     
        let eventData = { 'eventName': eventName, 'eventPayload': {} };
        if (eventName === 'Keyword Search') {
            eventData['eventPayload'] = eData;
            window['digitalData'] && (window['digitalData'].searches = eventData);
        } else if (eventName === 'Business Order Delivery Details Submitted') {
            let shippingMethod = {
                "orderDeliveryShipmentInfo": {
                    "shipmentShippingMethod": eData.shippingType,
                    "shipmentShippingCost": eData.shippingCost,
                    "shipmentETA": eData.shippingDescription
                }
            }
            eventData['eventPayload'] = shippingMethod;
        }
        const event = new CustomEvent('Error', {
            detail: eventData
        });
        window.dispatchEvent(event);
        window['digitalData'] && window['digitalData'].events.push(eventData);
    } catch(err) {
        console.log(err);
    }
}

export function eventProductViewTracking(pageType,eData) {
    let productViewEventPayload = { 'eventName': 'Product Details Page View', 'eventPayload': {res:eData} };
    let productsArray = []
        console.log("eventProductViewTracking",eData);
        let productInfo = {
            'productInfo': {
                'product':eData,
                'productID': eData?.id,
                'productName': eData?.name,
                'productDesc':eData?.description,
                'productCategory': "Subscription",
                'productType': 'Software',
                'productPrice': "",
                'productQuantity': 1,
                'productRatingAverage': '',
                'productReviewsTotal': '',
                "flowName": "Marketplace"
            }
        };
        productsArray.push(productInfo)
    
    // productViewEventPayload.eventPayload[pageType] = productDetails?.packageArray[0][pageType];
    productViewEventPayload.eventPayload['productsArray'] = productsArray;

    const cusEvent = new CustomEvent(productViewEventPayload.eventName, {
        detail: productViewEventPayload,
        bubbles: true,
        cancelable: true
    });
    window.dispatchEvent(cusEvent);
    window['digitalData'] && window['digitalData']?.events?.push(productViewEventPayload);
}

export function eventAddtocartTracking(eventName, eData, pageName, sourceName) {
    try{
        let addToCartEventPayload = {
            'eventName': eventName,
            'eventPayload': {
                'packagesArray': [],
                'productsArray': [],
                'discountsArray': [],
                'cartRes': eData

            }
        };
        let packgArray = {
            'packageInfo': {
                'packageID': '',
                'packagePriceTotal': ''
            }
        };
        let discountsArr = {
            "discountInfo": {
                "discountId": '',
                "discountName": '',
                "discountAmount": ''
            }
        }
        errorChange(packgArray.packageInfo);
        errorChange(discountsArr.discountInfo);
        let sftwareList = eData?.packages;
        Object.keys(sftwareList)?.forEach((key, i) => {
            let software = sftwareList[key]?.bussSubscriptionInfo;
            if (pageName === 'bussInfo') {
               
            //     let productArrInfo = {
            //         'productInfo': {
            //             'product':sftwareList[key],
            //             'productID': sftwareList[key]?.deviceSku,
            //             'productName': sftwareList[key]?.brand,
            //             'productCategory': sftwareList[key]?.deviceCategory,
            //             'productType': 'Software',
            //             'productQuantity': sftwareList[key]?.quantity || 1,
            //             "flowName": "Marketplace"
            //         }
            //     };
            // addToCartEventPayload.eventPayload.productsArray.push(productArrInfo);

            //     const softwareInfo = {
            //         "softwareLicenseInfo": {
            //           "softwareLicenseID":'',
            //           "softwareLicenseSKU":sftwareList[i]?.deviceSku,
            //           "softwareLicenseName":software?.itemName,
            //           "softwareLicenseType":software?.contentType,
            //           "softwareLicenseBrand":'',
            //           "softwareLicenseCategory":software?.catDisplayName,
            //           "softwareLicenseAutoRenewEnabledFlag":software?.autoRenewal,
            //           "softwareLicensePriceSubTotal":"",
            //           "softwareLicensePriceTaxTotal":"",
            //           "softwareLicensePriceTotal":software?.price,
            //           "softwareLicenseRetailPriceListed":"",
            //           "softwareLicenseSalePriceListed":software?.price,
            //           "softwareLicenseDuration":sftwareList[i]?.tenure,
            //           "softwareLicensePaymentFrequency":sftwareList[i]?.priceTypeBefore,
            //           "softwareLicensePaymentCadence":""
            //       }
            //   };
              const planInfo = {
                "productInfo": {
                    'product':software,
                    "productID": software?.pricePlanPackageType?.pppid,
                    "productName": software?.pricePlanPackageType?.pppDesc,
                    'productCategory': "Subscription",//software?.pricePlanPackageType?.pppType,
                    'productType': 'Software',
                    "productPrice": software?.pricePlanPackageType?.purchasePrice,
                    "productQuantity": sftwareList[key]?.quantity,
                    "flowName": "Marketplace"
                }
            };

                errorChange(planInfo?.productInfo);

                addToCartEventPayload.eventPayload.productsArray.push(planInfo);
                //packgArray.packageInfo['packageDevicesIncludedArray'] = packageDevicesIncludedArray;

            }
        });
        if (addToCartEventPayload.eventPayload.productsArray?.length > 0 ) {
                const cusEvent = new CustomEvent(eventName, {
                    detail: addToCartEventPayload,
                    bubbles: true,
                    cancelable: true
                });
            window.dispatchEvent(cusEvent);
            window['digitalData'] && window['digitalData'].events.push(addToCartEventPayload);
        }
    } catch(err) {
        console.log(err);
    }
}


export function errorChange(edata = {}) {
    try{
        Object?.keys(edata)?.forEach((k, indx) => {
            if (edata[k] == undefined || edata[k] == "undefined" || edata[k] == null || edata[k] === '') {
                edata[k] = "undefined";
            }
        });
    } catch(err) {
        console.log(err);
    }
}

export function eventShoppingCartInfoTracking(eventName, eData1, pageName, sourceName) {
    try{
        const sections = window.location.pathname.split('/').filter(item => item).slice(0, window.location.pathname.split('/').length);
        let byodCount = 0;
        let CpoCount = 0;
        let tradeInCount = 0;
        let newDevice = 0;
        let tradeInTotal = 0;
        let count = 0;
        let shoppingCartInfo;
        if (sourceName === 'clear_cart' || sourceName === 'clear_cart_switch_modal') {
            shoppingCartInfo = {
                'cartRes':eData1,
                'productsArray': [],
                'packagesArray': [],
                'discountsArray': [],
            };
        }
        else {
            shoppingCartInfo = {
                'cartRes':eData1,
                'shoppingCartID': '',
                'shoppingCartStatus': 'New', //New, Abandoned, Recovered
                // 'shoppingCartSubTotal': '',
                // 'shoppingCartTaxTotal': '',
                'shoppingCartOrderTotal': (sourceName === 'cart_switch') ? eData1?.totalAmounts?.dueToday : (eData1?.priceSummary?.total?.dueToday || ''),
                // 'shoppingCartOrderTotalMonthly': '',
                'shoppingCartOrderTaxTotalMonthly': eData1?.priceSummary?.tax?.dueToday || '',
                'shoppingCartPreferredContactMethod': '',
                'scheduledContactTimeSlot': '',
                'shoppingCartPackagesIncludedArray': [],
                'shoppingCartOrderDeliveryDetails': {
                    'orderDeliveryType': 'Online', //Online vs. in-store
                    'orderDeliveryShipmentsArray': [] //Accepts Order Delivery Shipment Objects
                },
                'shoppingCartTradeInTotalEstimate': tradeInTotal,
                'shoppingCartNewDevicesTotal': newDevice,
                'shoppingCartCpoDevicesTotal': CpoCount,
                'shoppingCartByodDevicesTotal': byodCount,
                'shoppingCartTradeInDevicesTotal': tradeInCount,
                'discountsArray': [],
                'shoppingCartDiscountsTotalAmount': 0,
                'shoppingCartTotalNumberOfDiscounts': 0,
                'sharedCartId': eData1?.cart?.cartId || '',
                'cartId': eData1?.cart?.cartId || ''
                // 'sharedCartId': eData1.sharedCartId || ''
            };
        }

        let packArray = {
            "packageInfo": {
                "packageID": '',
                "packagePriceTotal": '',
                "packagePlansIncludedArray": [],
                "packageDevicesIncludedArray": [],
                "packageAccessoriesIncludedArray": [],
                "packageFeaturesIncludedArray": []
            }
        };

        errorChange(shoppingCartInfo);
        errorChange(packArray.packageInfo);
        let productsArray = [];
        //let deviceList = eData1?.cart?.packages;
        //let accessoryList = {};//eData1['devices']['accessoryList'] = eData1?.cart?.accessories || {};

        let sftwareList = eData1?.cart?.packages;
        Object.keys(sftwareList)?.forEach((key, i) => {
            let software = sftwareList[key]?.bussSubscriptionInfo;

              const planInfo = {
                "productInfo": {
                    'product':software,
                    "productID": software?.pricePlanPackageType?.pppid,
                    "productName": software?.pricePlanPackageType?.pppDesc,
                    "productCategory": "Subscription",//software?.pricePlanPackageType?.pppType,
                    "productType": "Software",
                    //"productSubCategory": "",
                    "productPrice": software?.pricePlanPackageType?.purchasePrice,
                    "productQuantity": sftwareList[key]?.quantity,
                    "flowName": "Marketplace"
                }
             };

                errorChange(planInfo?.productInfo);

                productsArray.push(planInfo);
                //packgArray.packageInfo['packageDevicesIncludedArray'] = packageDevicesIncludedArray;

        });
        shoppingCartInfo['productsArray'] = productsArray;
        // if (sourceName !== 'clear_cart' && sourceName !== 'clear_cart_switch_modal') {
        //     shoppingCartInfo.shoppingCartPackagesIncludedArray.push(packArray);
        // }
        errorChange(shoppingCartInfo);

        if (eventName === 'Unified Shopping Cart Page View' || eventName === 'Shopping Cart Remove' || eventName === 'Unified Review Order Page Viewed') {
            let shopingCartPayload = { eventName: eventName, eventPayload: {shoppingCartInfo:{...shoppingCartInfo}} };
            if (!isMybizMfeOmni) { 
                const cusEvent = new CustomEvent(eventName, {
                    detail: shopingCartPayload,
                    bubbles: true,
                    cancelable: true
                });
                errorChange(shopingCartPayload);
                window['digitalData'] && window['digitalData'].events.push(shopingCartPayload);
                window.dispatchEvent(cusEvent);
                window['digitalData'].isUniqROS = eventName === 'Unified Review Order Page Viewed' ? false:true;
            }
        } 

        if(!isMybizMfeOmni && window['digitalData']){
            (window['digitalData'].shoppingCartInfo = shoppingCartInfo)
        };
        
    } catch(err) {
        console.log(err);
    }
}

export function errorCheck(checkValue) {
    try {
        var returnVal = "";
        if (typeof checkValue != undefined || (typeof checkValue != undefined && checkValue && checkValue != "" && checkValue != null)) returnVal = checkValue;
        // if(returnWithError) return typeof checkValue;
        return returnVal;
    } catch(err) {
        console.log(err)
    }
}

export function orderShoppingInfoUpdate(SubTotal, TaxTotal, TotalMonthly) { 
    try {
        eventShoppingCartInfoTracking('', JSON.parse(localStorage._cartData), 'shoppingcartInfo', '');
        if (window['digitalData']) {
            window['digitalData']['shoppingCartInfo']['shoppingCartSubTotal'] = SubTotal;
            window['digitalData']['shoppingCartInfo']['shoppingCartOrderTotalMonthly'] = TotalMonthly;
            window['digitalData']['shoppingCartInfo']['shoppingCartTaxTotal'] = TaxTotal;
        }
    } catch(err) {
        console.log(err)
    }
}

export function eventSaveCartInfoTracking(eventName, eData = {}, pageName, sourceName) {
    try {
        let saveCartEventPayload = {
            "eventName": eventName,
            "eventPayload": {}
        }
        if (eventName === 'Save Cart Form Presented') {
            saveCartEventPayload.eventPayload = eData;
        } else {
            eventShoppingCartInfoTracking('', JSON.parse(localStorage._cartData), 'shoppingcartInfo', 'saveCart');
            window['digitalData'] && (saveCartEventPayload.eventPayload = window['digitalData']['shoppingCartInfo']);
        }
        errorChange(saveCartEventPayload);
        const cusEvent = new CustomEvent(eventName, {
            detail: saveCartEventPayload,
            bubbles: true,
            cancelable: true
        });
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(saveCartEventPayload);
    } catch(err) {
        console.log(err)
    }
}

export function evntFilterByTracking(eventName, eData = {}, pageName, sourceName) {
    try {
        let filterEventPayload = { 'eventName': eventName, 'eventPayload': {} };
    
        if (eventName === 'Filter By') {
            let filtersAddedArray = [], eDataFilter;
            if (pageName === 'accessory_gridwall_page') {
                eDataFilter = eData.accessoryFilters;
            } else if (pageName === 'device_gridwall_page') {
                eDataFilter = eData.deviceFilters;
            }
            Object.keys(eDataFilter).forEach((key, i) => {
                let filersList = eDataFilter[key];
                for (let index = 0; index < filersList.length; index++) {
                    let el = filersList[index];
                    let filter = {
                        "filterInfo": {
                            "filterID": el.docCount,
                            "filterSelected": el.checked,
                            "filterType": el.type,
                            "filterValue": el.key
                        }
                    };
                    errorChange(filter);
                    filtersAddedArray.push(filter);
                }
            });
            filterEventPayload.eventPayload['filtersAddedArray'] = filtersAddedArray
        } else if (eventName === 'Sort By') {
            let filtersAddedArray = [{
                "filterInfo": {
                    "filterID": '',
                    "filterSelected": '',
                    "filterType": 'Sort',
                    "filterValue": eData
                }
            }];
            errorChange(filtersAddedArray[0].filterInfo);
            filterEventPayload.eventPayload['filtersAddedArray'] = filtersAddedArray;
        }
    
        const cusEvent = new CustomEvent(eventName, {
            detail: filterEventPayload,
            bubbles: true,
            cancelable: true
        });
        window.dispatchEvent(cusEvent);
        if (window['digitalData']) {
            window['digitalData'].events.push(filterEventPayload);
            window['digitalData'].filters = filterEventPayload;
        }
    } catch(err) {
        console.log(err)
    }
}

export function eventOrderInfoTracking(eventName, eData = {}, pageName, sourceName, orderResp) {
    try {
        let orderEventEventPayload = { eventName: eventName, eventPayload: {} };
        // let eData = JSON.parse(localStorage._cartData);
        let orderDetails = orderResp; // eData.orderDetails;
        let byodCount = 0;
        let CpoCount = 0;
        let tradeInCount = 0;
        let newDevice = 0;
        let tradeInTotal = 0;
        let orderInfo = {
            'orderRes':eData,
            'shoppingCartID': eData?.cart?.cartId || '',
            'shoppingCartStatus': 'New', //New, Abandoned, Recovered
            'shoppingCartSubTotal': '',
            'shoppingCartTaxTotal': eData?.cart?.totalAmounts?.totalTaxAmount,
            'shoppingCartOrderTotal': eData?.cart?.totalAmounts?.dueToday,
            'shoppingCartOrderTotalMonthly': eData?.cart?.totalAmounts?.dueMonthly,
            'shoppingCartOrderTaxTotalMonthly': eData?.cart?.totalAmounts?.totalTaxAmount,
            'shoppingCartPreferredContactMethod': orderDetails?.custContactPref,
            'scheduledContactTimeSlot': orderDetails?.returnCallSlot,
            'shoppingCartPackagesIncludedArray': [],
            'shoppingCartOrderDeliveryDetails': {
                'orderDeliveryType': 'Online', //Online vs. in-store
                'orderDeliveryShipmentsArray': [] //Accepts Order Delivery Shipment Objects
            },
            'shoppingCartTradeInTotalEstimate': tradeInTotal,
            'shoppingCartNewDevicesTotal': newDevice,
            'shoppingCartCpoDevicesTotal': CpoCount,
            'shoppingCartByodDevicesTotal': byodCount,
            'shoppingCartTradeInDevicesTotal': tradeInCount,
            'discountsArray': [],
            'shoppingCartDiscountsTotalAmount': 0,
            'shoppingCartTotalNumberOfDiscounts': 0,
            'purchaseID': orderDetails?.orderNumber,
            "totalDevicesCount": Object.keys(eData?.cart?.packages || {}).length,
            "totalAccessoriesCount": orderDetails?.cartSummary?.totalAccessoriesCount,
            "totalPlansCount": orderDetails?.cartSummary?.totalPlansCount,
            "totalFeaturesCount": orderDetails?.cartSummary?.totalFeaturesCount,
            "totalByodCount": orderDetails?.cartSummary?.totalByodCount,
            "totalTradeInCount": orderDetails?.cartSummary?.totalTradeInCount
        };
        errorChange(orderInfo);
        errorChange(orderInfo?.shoppingCartOrderDeliveryDetails);

        let packArray = {
            "packageInfo": {
                "packageID": '',
                "packagePriceTotal": '',
                "packagePlansIncludedArray": [],
                "packageDevicesIncludedArray": [],
                "packageAccessoriesIncludedArray": [],
                "packageFeaturesIncludedArray": []
            }
        };
        errorChange(packArray?.packageInfo);
    
        let productsArray = [];
        let sftwareList = eData?.cart?.packages;
        Object.keys(sftwareList)?.forEach((key, i) => {
            let software = sftwareList[key]?.bussSubscriptionInfo;

              const planInfo = {
                "productInfo": {
                    'product':software,
                    "productID": software?.pricePlanPackageType?.pppid,
                    "productName": software?.pricePlanPackageType?.pppDesc,
                    "productCategory": "Subscription",//software?.pricePlanPackageType?.pppType,
                    "productType": "Software",
                    // "productSubCategory": "Subscription",
                    "productPrice": software?.pricePlanPackageType?.purchasePrice,
                    "productQuantity": sftwareList[key]?.quantity,
                    "flowName": "Marketplace"
                }
             };

                errorChange(planInfo?.productInfo);

                productsArray.push(planInfo);
                //packgArray.packageInfo['packageDevicesIncludedArray'] = packageDevicesIncludedArray;
        });
        orderInfo['productsArray'] = productsArray;
        orderInfo.shoppingCartPackagesIncludedArray.push(packArray);
        errorChange(orderInfo);
        errorChange(orderInfo['productsArray']);
    
        orderEventEventPayload.eventPayload = {shoppingCartInfo:{...orderInfo,isReact:true,isAngular:false}};

        if (window['digitalData'] && !isMybizMfeOmni) {
            window['digitalData'].shoppingCartInfo = orderEventEventPayload.eventPayload;
            window['digitalData'].events.push(orderEventEventPayload);
            window['digitalData'].isUniqBOS = false;
        }

        if (!isMybizMfeOmni) {
            const cusEvent = new CustomEvent(eventName, {
                detail: orderEventEventPayload,
                bubbles: true,
                cancelable: true
            });
            window.dispatchEvent(cusEvent);
        }

    } catch(err) {
        console.log(err)
    }
}


export function eventCartRetrieved(eventName, eData = {}, pageName, sourceName) {
    try {
        let eventCartRetrievPayload = { eventName: eventName, eventPayload: eData };
        const cusEvent = new CustomEvent(eventName, {
            detail: eventCartRetrievPayload,
            bubbles: true,
            cancelable: true
        });
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(eventCartRetrievPayload);
    } catch(err) {
        console.log(err)
    }
}

export function eventCheckDevice(eventName, eData = {}, pageName, sourceName) {
    try {
        let checkDevicePayload = {
            'eventName': eventName, 'eventPayload':
                { 'deviceFullDetail': JSON.parse(JSON.stringify(eData.deviceFullDetail)) }
        };
        if (eventName === 'Check My Device Success') {
            checkDevicePayload.eventPayload.compatibleWithNetwork = true
        } else if (eventName === "Check My Device Incompatible") {
            checkDevicePayload.eventPayload.compatibleWithNetwork = false
        }
        checkDevicePayload.eventPayload.deviceId = eData.deviceId;
        checkDevicePayload.eventPayload.simID = nullCheck(eData.simID);
        checkDevicePayload.eventPayload.simCondition = nullCheck(eData.simCondition)
    
        const cusEvent = new CustomEvent(eventName, {
            detail: checkDevicePayload,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(checkDevicePayload);
    } catch(err) {
        console.log(err)
    }
}

export function eventSimSelection(eventName, eData = {}, pageName, sourceName) {
    try {
        let simEventPayload = { 'eventName': eventName, 'eventPayload': { 'deviceFullDetail': JSON.parse(JSON.stringify(eData.deviceFullDetail)) } };
        simEventPayload.eventPayload.deviceId = eData.deviceId;
        simEventPayload.eventPayload.simID = nullCheck(eData.simID);
        simEventPayload.eventPayload.simCondition = nullCheck(eData.sim)
        if (eventName === 'New SIM Card Requested') {
            simEventPayload.eventPayload.compatibleWithNetwork = 'undefined';
        } else if (eventName === 'Existing SIM Card Validation Requested') {
            simEventPayload.eventPayload.compatibleWithNetwork = 'undefined';
        } else if (eventName === 'Check My SIM Success') {
            simEventPayload.eventPayload.compatibleWithNetwork = true;
        } else if (eventName === 'Check My SIM Fail') {
            simEventPayload.eventPayload.compatibleWithNetwork = false;
        }
    
        const cusEvent = new CustomEvent(eventName, {
            detail: simEventPayload,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(simEventPayload);
    } catch(err) {
        console.log(err)
    }

}

export function eventTradeIn(eventName, eData = {}, pageName, sourceName) {
    try {

        
        let deviceFullDetails;
        let tradeInDevice = {
            'eventName': eventName, 'eventPayload': { 'deviceFullDetail': deviceFullDetails }
        };
    
        if (eventName === 'Trade-in Device Added') {
            let eData2 = eData.devices[0]
            deviceFullDetails = {
                "backOrder": eData2.backOrder,
                "brandName": eData.brandSelected,
                "carouselImageset": eData2.imageName,
                "category": eData2.category, //Confirm this will work for device type with values such as "4G Smartphone"
                "compatibleWithPlan": eData2.compatibleWithPlan,
                "compatibleWithNetwork": eData2.compatibleWithNetwork, //True or false.
                "contractTerm": eData2.contractTerm,
                "cssColor": eData.selectedDevice.colorCssStyle,
                "deliverBy": eData2.deliverBy,
                "deviceCarrier": eData.selectedCarrier,
                "deviceColor": eData2.color,
                "deviceCondition": eData2.deviceCondition, //The condition of a trade-in device as entered by a user, or 'Certified' for a CPO, or 'New' if new
                "deviceId": eData2.deviceId,
                "deviceManufacturer": eData2.equipMake,
                "deviceModel": eData2.equipModel,
                "devicePaymentFinalPrice": eData2.devicePaymentFinalPrice,
                "devicePaymentPrice": eData2.devicePaymentPrice,
                "devicePaymentTenure": eData2.tenure,
                "deviceSize": eData2.devicesSize, //The size of the device
                "deviceStorageAmount": eData2.capacity, //Amount of storage available on the device (eg.g 64GB, etc.)
                "deviceSkuId": eData2.recycleDeviceSku,
                "deviceTradeInValue": eData2.appliedPrice, //Estimated value of trade-in device
                "fullName": eData2.equipModel + " " + (eData2.capacity ? eData2.capacity : ''),
                "hasPaymentMethods": eData2.hasPaymentMethods,
                "imageSet": eData2.imageName,
                "imei": eData2.deviceId,
                "byod": (eData2.byod ? 'Yes' : 'No'),
                "isTradeIn": 'Yes', //True or False - Is the device a trade-in?
                "itemPrice": eData2.appliedPrice,
                "name": eData.selectedDevice.bccModel,
                "oneYearContractFinalPrice": eData2.oneYearContractFinalPrice,
                "oneYearContractPrice": eData2.oneYearContractPrice,
                "outOfStock": eData2.outOfStock,
                "preOrder": eData2.preOrder,
                "productName": eData2.modelName,
                "rating": eData2.rating,
                "reviewCount": eData2.reviewCount,
                "shipmentDelay": eData2.shipmentDelay,
                "simSku": eData2.simSku,
                "simId": eData2.simId,
                "simCondition": eData2.simCondition, //New or Used
                "twoYearContractFinalPrice": eData2.twoYearContractFinalPrice,
                "twoYearContractPrice": eData2.twoYearContractPrice
            }
            errorChange(deviceFullDetails);
        }
        else if (eventName === 'Trade-in Device Removed') {
    
            let eData2 = eData.tradInInfo
            deviceFullDetails = {
                "backOrder": eData2.backOrder,
                "brandName": eData2.equipMake,
                "carouselImageset": eData2.imageName,
                "category": eData2.category, //Confirm this will work for device type with values such as "4G Smartphone"
                "compatibleWithPlan": eData2.compatibleWithPlan,
                "compatibleWithNetwork": eData2.compatibleWithNetwork, //True or false.
                "contractTerm": eData2.contractTerm,
                "cssColor": eData2.colorCssStyle,
                "deliverBy": eData2.deliverBy,
                "deviceCarrier": eData2.equipCarrier,
                "deviceColor": eData2.color,
                "deviceCondition": eData2.deviceCondition, //The condition of a trade-in device as entered by a user, or 'Certified' for a CPO, or 'New' if new
                "deviceId": eData2.deviceId,
                "deviceManufacturer": eData2.equipMake,
                "deviceModel": eData2.equipModel,
                "devicePaymentFinalPrice": eData2.devicePaymentFinalPrice,
                "devicePaymentPrice": eData2.devicePaymentPrice,
                "devicePaymentTenure": eData2.tenure,
                "deviceSize": eData2.devicesSize, //The size of the device
                "deviceStorageAmount": eData2.capacity, //Amount of storage available on the device (eg.g 64GB, etc.)
                "deviceSkuId": eData2.recycleDeviceSku,
                "deviceTradeInValue": eData2.appliedPrice, //Estimated value of trade-in device
                "fullName": eData2.equipModel + " " + (eData2.capacity ? eData2.capacity : ''),
                "hasPaymentMethods": eData2.hasPaymentMethods,
                "imageSet": eData2.imageName,
                "imei": eData2.deviceId,
                "byod": (eData2.byod ? 'Yes' : 'No'),
                "isTradeIn": 'Yes', //True or False - Is the device a trade-in?
                "itemPrice": eData2.appliedPrice,
                "name": eData2.equipModel,
                "oneYearContractFinalPrice": eData2.oneYearContractFinalPrice,
                "oneYearContractPrice": eData2.oneYearContractPrice,
                "outOfStock": eData2.outOfStock,
                "preOrder": eData2.preOrder,
                "productName": eData2.modelName,
                "rating": eData2.rating,
                "reviewCount": eData2.reviewCount,
                "shipmentDelay": eData2.shipmentDelay,
                "simSku": eData2.simSku,
                "simId": eData2.simId,
                "simCondition": eData2.simCondition, //New or Used
                "twoYearContractFinalPrice": eData2.twoYearContractFinalPrice,
                "twoYearContractPrice": eData2.twoYearContractPrice
            }
            errorChange(deviceFullDetails);
    
        }
    
        tradeInDevice.eventPayload.deviceFullDetail = deviceFullDetails
        const cusEvent = new CustomEvent(eventName, {
            detail: tradeInDevice,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(tradeInDevice);
    } catch(err) {
        console.log(err)
    }
}


export function storeAppointment(eventName, eData = {}, pageName, sourceName) {
    try {
        let storePayload = {
            'eventName': eventName,
            'eventPayload': {
                'optionSelected': eData.purposeOfVisit
            }
        }
        const cusEvent = new CustomEvent(eventName, {
            detail: storePayload,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(storePayload);
    } catch(err) {
        console.log(err)
    }
}

export function  customerDetails(eventName, eData = {}, pageName, sourceName) {
    try {
        let storePayload = {
            'eventName': eventName,
            "eventPayload": {
                "referenceNumber": eData.appointmentInfo.appointmentId,
                "storeName": eData.appointmentInfo.storeDetails.storeName,
                "appointmentReason": eData.appointmentInfo.purposeDetails.purpose,
                "appointmentDate": eData.appointmentInfo.purposeDetails.appointmentDate
            } //end eventPayload
        }
        const cusEvent = new CustomEvent(eventName, {
            detail: storePayload,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(storePayload);
    } catch(err) {
        console.log(err)
    }
}

export function eventPlanError(eventName, eData = {}, pageName, sourceName) {
    try {

        let pageN = window.location.href.split('/').pop();
        let planError;
        if (pageN === 'plans') {
            if (eData.status) {
                planError = {
                    "eventName": "Error Encountered",
                    "eventPayload": {
                        "errorInfo": {
                            "errorID": eData.status.statusCode,
                            "errorCategory": eData.status.statusMessage,
                            "errorName": eData.status.message,
                            "errorMessage": sourceName
                        }
                    }
                }
            }
            else if (eData.serviceStatus) {
                planError = {
                    "eventName": "Error Encountered",
                    "eventPayload": {
                        "errorInfo": {
                            "errorID": eData.serviceStatus.statusCode,
                            "errorCategory": eData.serviceStatus.statusMessage,
                            "errorName": eData.serviceStatus.message,
                            "errorMessage": sourceName
                        }
                    }
                }
            }
            else {
                // eData.slice(eData.indexOf(':')+1,eData.indexOf('Message:'))
                planError = {
                    "eventName": "Error Encountered",
                    "eventPayload": {
                        "errorInfo": {
                            "errorID": "",
                            "errorCategory": "",
                            "errorName": "",
                            "errorMessage": eData
                        }
                    }
                }
            }
    
            errorChange(planError.eventPayload.errorInfo);
            const cusEvent = new CustomEvent(eventName, {
                detail: planError,
                bubbles: true,
                cancelable: true
            });
            window.dispatchEvent(cusEvent);
            window['digitalData'] && window['digitalData'].events.push(planError);
        }
    } catch(err) {
        console.log(err)
    }
}

export function eventDDIATracking(eventName, eData, pageName, sourceName) {
    try {
        let dataPayload = {
            'eventName': eventName,
            "eventPayload": eData //end eventPayload
        }
        const cusEvent = new CustomEvent(eventName, {
            detail: dataPayload,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(dataPayload);
    } catch(err) {
        console.log(err)
    }
}

export function eventLoopQual(eventName, requestData, responseData) {
    try {
        let dataPayload
        if (eventName === 'Loop Qualification Attempt') {
            dataPayload = {
                'eventName': eventName,
                "eventPayload": requestData
            }
        }
        else {
            dataPayload = {
                'eventName': eventName,
                "eventPayload":
                {
                    "request": requestData,
                    "response": responseData
                } //end eventPayload
            }
        }
    
        const cusEvent = new CustomEvent(eventName, {
            detail: dataPayload,
            bubbles: true,
            cancelable: true
        });
    
        window.dispatchEvent(cusEvent);
    } catch(err) {
        console.log(err)
    }
    window['digitalData'] && window['digitalData'].events.push(dataPayload);
}

export function eventCreditInfoTracking(eventName, eData = {}, pageName, sourceName) {
    try{
        let CreditInfoData = {
            "orgRes":eData,
            "organizationInfo": {
                "organizationId": '',
                "organizationName": '',
                "organizationCreditStatus": '',
                "organizationLinkedContractsArray": []
            }
        };
        if (eventName === 'Business Credit Details Submitted') {
            CreditInfoData.organizationInfo.organizationName = eData?.companyName;//eData.companyInfo.name;
        } else if (eventName === 'Credit Check Approved') {
            CreditInfoData = window['digitalData']?.organizationInfo;
            CreditInfoData?.organizationInfo?.organizationCreditStatus ? CreditInfoData.organizationInfo.organizationCreditStatus = "SUCCESS" : ''; //'Approved';
        }
        else if (eventName === 'Credit Check UnApproved') {
            CreditInfoData = window['digitalData']?.organizationInfo;
            CreditInfoData?.organizationInfo?.organizationCreditStatus ? CreditInfoData.organizationInfo.organizationCreditStatus = "FAILURE" : '';//'UnApproved';
        }
        errorChange(CreditInfoData?.organizationInfo);
        // window['digitalData'].organizationInfo = CreditInfoData;
        let busInfoEvntPayload = { 'eventName': eventName, 'eventPayload': CreditInfoData };
        const cusEvent = new CustomEvent(eventName, {
            detail: busInfoEvntPayload,
            bubbles: true,
            cancelable: true
        });
        window.dispatchEvent(cusEvent);
        window['digitalData'].events.push(busInfoEvntPayload);
    } catch (err) {
        console.log(err)
    }
}

// TBD
export function  errorEncounter(eventName, errorData) {
    let errorEventPayload = {
        "eventName": "Error Encountered",
        "eventPayload": errorData
    };
    const cusEvent = new CustomEvent(eventName, {
        detail: errorEventPayload,
        bubbles: true,
        cancelable: true
    });

    window.dispatchEvent(cusEvent);
    window['digitalData'].events.push(errorEventPayload);
}
export function  automationThrottleParam(ThrottleData) {
    if (ThrottleData) {
        window['digitalData'] && (window['digitalData'].pageInfo.throttleFlow = "Automation");
    } else {
        window['digitalData'] && (window['digitalData'].pageInfo.throttleFlow = "NonAutomation");
    }

}
//completed
export function eventBusInfoTracking(eventName, eData = {}, pageName, sourceName) {
    try {
        let busInfoData = {
            "orgRes":eData,
            "organizationInfo": {
                "organizationName": '',
                "organizationCreditStatus": '',
                "organizationLinkedContractsArray": []
            }
        };
        if (eventName === 'Business Credit Details Submitted') {
            busInfoData.organizationInfo.organizationName = eData?.companyName;
        } else if (eventName === 'Business Credit Details Status Response') {
            window['digitalData'] && (busInfoData = window['digitalData']?.organizationInfo);
            busInfoData.organizationInfo.organizationCreditStatus = eData; //'Approved';
        }
        errorChange(busInfoData.organizationInfo);
        // window['digitalData'].organizationInfo = busInfoData;
        let busInfoEvntPayload = { 'eventName': eventName, 'eventPayload': busInfoData };
        const cusEvent = new CustomEvent(eventName, {
            detail: busInfoEvntPayload,
            bubbles: true,
            cancelable: true
        });
        window.dispatchEvent(cusEvent);
        window['digitalData'] && window['digitalData'].events.push(busInfoEvntPayload);
    } catch (err) {
        console.log(err)
    }
}

export function  ThrottleFlowType(ThrottleFlowData) {
    if (ThrottleFlowData == "prospect") {
        window['digitalData'] && (window['digitalData'].pageInfo.throttleFlowType = "REGULAR");
    } else {
        window['digitalData'] && (window['digitalData'].pageInfo.throttleFlowType = ThrottleFlowData);
    }
}
export function  plansFirstSelection(selectedPlan, billingCode) {

    window['digitalData'] && (window['digitalData'].pageInfo.planID = selectedPlan);
    window['digitalData'] && (window['digitalData'].pageInfo.billingCode = billingCode);
    //window['digitalData'].events.eventPayload.packagesArray.packageInfo.packagePlansIncludedArray.planInfo.billingCode = billingCode;

}

/*** Package PDP  */
export function  addPackageToCartTracking(eventName, eData = {}, pageName, sourceName, cartData = {}) {
    /**  Adobe launch tracking */
    const addToCartEventPayload = {
        'eventName': eventName,
        'eventPayload': {
            'packagesArray': [],
            'productsArray': []
        }
    };
    const packgArray = {
        'packageInfo': {
            'packageID': eData?.id,
            'packageName': eData?.name,
            'packagePriceTotal': '',
            'recommendedPackage': eData?.recommendedPackage,
            'packageType': eData?.type

        }
    };
    errorChange(packgArray.packageInfo);
    if (pageName === 'packageInfo') {
        const packageDevicesIncludedArray = [{
            'deviceInfo': {
                'deviceID': eData?.deviceId,
                'deviceSKU': eData?.deviceSku,
                'deviceName': eData?.productName,
                'deviceBrand': eData?.brand,
                'deviceCategory': eData?.deviceCategory,
                'deviceDescription': eData?.description,
                'deviceRetailPriceListed': eData?.itemRetailPrice,
                'deviceSalePriceListed': eData?.retailTwoYrPrice,
                'deviceRatingAverage': eData?.overallRating,
                'deviceReviewTotal': eData?.reviewCount,
                'deviceDisclaimer': 'undefined',
                'devicePromotionDetails': 'undefined',
                'deviceColorOptionSelected': eData?.color,
                'deviceStorageOptionSelected': eData?.capacity,
                'devicePaymentOptionSelected': eData?.amount,
                "deviceCarrier": eData?.deviceCarrier,
                "deviceColor": eData?.color,
                "deviceCondition": eData?.deviceCondition,
                "deviceManufacturer": eData?.deviceManufacturer,
                "deviceModel": eData?.model,
                "deviceSize": eData?.deviceSize,
                "deviceStorageAmount": eData?.capacity,
                "deviceSkuId": eData?.skuCode
            }
        }];
        const productsArray = {
            'productInfo': {
                'productID': eData?.deviceSku,
                'productName': eData?.productName,
                'productCategory': eData?.deviceCategory,
                'productType': 'Device',
                'productPrice': eData?.amount,
                'productQuantity': 1,
                'productRatingAverage': eData?.overallRating,
                'productReviewsTotal': eData?.reviewCount,
                'productBrand': eData?.brand,
                'productMemorySize': eData?.capacity,
                'productColor': eData?.color,
                "productPurchaseCategory": 'New Purchase',
                'productDetails': eData
            }
        };
        errorChange(packageDevicesIncludedArray[0].deviceInfo);
        errorChange(productsArray.productInfo);

        addToCartEventPayload.eventPayload.productsArray.push(productsArray);
        packgArray.packageInfo['packageDevicesIncludedArray'] = packageDevicesIncludedArray;

        const packagePlansIncludedArray = [{
            'planInfo': {
                'planID': '',
                'planSKU': eData.plan?.pricePlanCode,
                'planName': eData.plan?.pricePlanDesc,
                'planType': eData.plan?.groupType,
                'planCategory': eData.plan?.planCatType,
                'planRetailPriceListed': eData.plan?.planPrice,
                'planSalePriceListed': eData.plan?.planPreviousPrice
            }
        }];
        const productsPlanArray = {
            'productInfo': {
                'productID': eData.plan?.pricePlanCode,
                'productName': eData.plan?.pricePlanDesc,
                'productCategory': eData.plan?.groupType,
                'productType': 'Plan', // eData.type,
                'productPrice': eData.plan?.monthlyCharge,
                'productQuantity': 1,
                'productRatingAverage': '',
                'productReviewsTotal': '',
                'planDetails': eData.plan
            }
        };
        errorChange(packagePlansIncludedArray[0].planInfo);
        errorChange(productsArray.productInfo);
        addToCartEventPayload.eventPayload.productsArray.push(productsPlanArray);
        packgArray.packageInfo['packagePlansIncludedArray'] = packagePlansIncludedArray;


        const packageFeaturesIncludedArray = [];
        const featureList = eData.features || {};

        Object.keys(featureList).forEach(key => {
            const element = {
                'featureInfo': {
                    'featureID': featureList[key]?.visFeatureCode,
                    'featureSKU': featureList[key]?.visFeatureCode,
                    'featureName': featureList[key]?.featureDesc,
                    'featureCategory': featureList[key]?.type
                }
            };
            const productsFeatureArray = {
                'productInfo': {
                    'productID': featureList[key]?.visFeatureCode,
                    'productName': featureList[key]?.featureDesc,
                    'productCategory': featureList[key]?.type,
                    'productType': 'Feature',
                    'productPrice': featureList[key]?.featurePrice,
                    'productQuantity': 1,
                    'productRatingAverage': 'undefined',
                    'productReviewsTotal': 'undefined',
                    'featureDetails': featureList[key]

                }
            };
            packageFeaturesIncludedArray.push(element);
            addToCartEventPayload.eventPayload.productsArray.push(productsFeatureArray);
        });

        packgArray.packageInfo['packageFeaturesIncludedArray'] = packageFeaturesIncludedArray;
    }

    addToCartEventPayload.eventPayload.packagesArray.push(packgArray);


    const cusEvent = new CustomEvent(eventName, {
        detail: addToCartEventPayload,
        bubbles: true,
        cancelable: true
    });
    window.dispatchEvent(cusEvent);
    window['digitalData'].events.push(addToCartEventPayload);
}


export function eventNewLoopQual(eventName, loopQualDlData) {
    let loopQualeventPayload = {
        'eventName': eventName,
        "eventPayload": {}
    };

    let loopQualDlPayload = {
        res:loopQualDlData,
        addressId: 'NA',
        entrypoint: 'NA',
        type: '',
        response: {
            type: window.location.pathname,
            data: loopQualDlData,
        },
    };

    if (loopQualDlData.Qualified_5g) {
        loopQualDlData['type'] = "5g-landing";
    } else if (loopQualDlData.Qualified_4g) {
        loopQualDlData['type'] = "4g-landing";
    }

    loopQualeventPayload.eventPayload = {...loopQualDlPayload,isReact:true,isAngular:false};

    const cusEvent = new CustomEvent(eventName, {
        detail: loopQualeventPayload,
        bubbles: true,
        cancelable: true
    });

    window.dispatchEvent(cusEvent);
    window['digitalData'] && window['digitalData'].events.push(loopQualeventPayload);
}

export function setBussCredit(businessCreditValue) {
    if (businessCreditValue === 'BLENDED') {
        window['digitalData'] && (window['digitalData'].pageInfo['businessCredit'] = 'Social Security Number');
    } else if (businessCreditValue === 'BizOnlyCredit') {
        window['digitalData'] && (window['digitalData'].pageInfo['businessCredit'] = 'Federal Tax ID EIN');
    }
}
export function newCreditOption(newCreditChoice) {
    if (newCreditChoice === 'BizOnlyCredit') {
        window['digitalData'] && (window['digitalData'].pageInfo['dba_isign_new_credit_option'] = 'Without Social Security Number');
    } else if (newCreditChoice === 'BLENDED') {
        window['digitalData'] && (window['digitalData'].pageInfo['dba_isign_new_credit_option'] = 'Social Security Number AND Federal tax ID');
    } else if (newCreditChoice === 'DBA') {
        window['digitalData'] && (window['digitalData'].pageInfo['dba_isign_new_credit_option'] = 'Only Social Security Number');
    }
    else {
        window['digitalData'] && (window['digitalData'].pageInfo['dba_isign_new_credit_option'] = 'undefined');
    }
}
export function creditHoldCode(creditHoldStatusCode) {
    if (creditHoldStatusCode === 'HD-AN') {
        window['digitalData'].pageInfo['creditHold'] = 'HD_AN More information and hours of operation';
    } else if (creditHoldStatusCode === 'HD-DH') {
        window['digitalData'].pageInfo['creditHold'] = 'HD-DH Outstanding balance and hours of operation';
    } else if (creditHoldStatusCode === 'HD-BU') {
        window['digitalData'].pageInfo['creditHold'] = 'HD-BU More information and submitted BusinessCreditDoc';
    } else if (creditHoldStatusCode === 'HD-FR') {
        window['digitalData'].pageInfo['creditHold'] = 'HD-FR More information and available 24X7';
    }
    else {
        window['digitalData'].pageInfo['creditHold'] = creditHoldStatusCode;
    }
}